import {
  Button,
  Card,
  Form,
  Input,
  message,
  Select,
  App,
  Upload,
  Row,
  Col,
} from "antd";
import { useEffect, useState } from "react";
import { ADD_GAME } from "../../apis/apis";
import { useNavigate } from "react-router-dom";
import {
  LeftOutlined,
  Loading3QuartersOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import CulsightPageLoader from "../../components/CulsightPageLoader";
import CustomRichTextEditor from "../../components/CustomTextEditor";
import ScormUploader from "../../components/ScromUploader";

export default function AddGame() {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();

  // Thumbnail
  const [thumbnail, set_thumbnail] = useState("");
  const [thumbnail_api, set_thumbnail_api] = useState("");

  // Form Fields
  const [title, set_title] = useState("");
  const [tag, set_tag] = useState([]);
  const [description, set_description] = useState("");

  // SCORM
  const [scorm_file, set_scorm_file] = useState("");
  const [scormUploading, set_scormUploading] = useState(false);

  // Errors
  const [errors, set_errors] = useState("");
  const [thumbnailError, setthumbnailError] = useState("");

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }

    set_thumbnail_api(info.file);

    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        set_thumbnail(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);
      message.error("Upload failed. Please try again.");
    }
  };

  const uploadButton = (
    <button
      type="button"
      style={{
        border: 0,
        background: "none",
      }}
    >
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined style={{ color: "#fff" }} />
      )}

      <div
        style={{
          marginTop: 8,
          color: "#fff",
        }}
      >
        Upload
      </div>
    </button>
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const onFinish = async () => {
    if (scormUploading) return;

    setLoading(true);

    const FORM_DATA = new FormData();

    FORM_DATA.append("thumbnail", thumbnail_api);
    FORM_DATA.append("title", title);
    FORM_DATA.append("tag", tag);
    FORM_DATA.append("description", description);
    FORM_DATA.append("scorm_file", scorm_file);

    try {
      const response = await ADD_GAME(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        navigate("/games");
      } else {
        setLoading(false);
        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error"),
      );
    }
  };

  return (
    <div className="lms-body">
      <Card>
        <Row>
          <Col span={12}>
            <h2>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/games")}
              >
                <LeftOutlined />
              </span>{" "}
              Game Details
            </h2>
          </Col>
        </Row>

        <h2>Add Game</h2>

        {loading ? (
          <CulsightPageLoader />
        ) : (
          <Form
            layout="vertical"
            form={form}
            autoComplete="off"
            validateTrigger="onSubmit"
            onFinish={onFinish}
          >
            <Form.Item label="Upload Game Photo here">
              <Upload
                name="thumbnail"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={(file) => {
                  const isImage =
                    file.type === "image/jpeg" ||
                    file.type === "image/png" ||
                    file.type === "image/jpg";

                  const isLt512KB = file.size <= 512 * 1024;

                  if (!isImage) {
                    set_thumbnail("");
                    set_thumbnail_api("");
                    setthumbnailError("Only JPG/PNG files are allowed.");
                    return false;
                  }

                  if (!isLt512KB) {
                    set_thumbnail("");
                    set_thumbnail_api("");
                    setthumbnailError(
                      "Thumbnail must be smaller than or equal to 512KB.",
                    );
                    return false;
                  }

                  const img = new Image();
                  img.src = URL.createObjectURL(file);

                  img.onload = () => {
                    const { width, height } = img;

                    if (width === 490 && height === 320) {
                      setthumbnailError("");

                      getBase64(file, (url) => set_thumbnail(url));
                      set_thumbnail_api(file);
                    } else {
                      set_thumbnail("");
                      set_thumbnail_api("");
                      setthumbnailError(
                        "Image must be exactly 490 x 320 pixels.",
                      );
                    }
                  };

                  return false;
                }}
                onChange={handleChange}
              >
                {thumbnail ? (
                  <img
                    src={thumbnail}
                    alt="thumbnail"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>

              {thumbnailError && (
                <span
                  style={{
                    color: "red",
                    display: "block",
                    marginTop: 8,
                  }}
                >
                  {thumbnailError}
                </span>
              )}

              {errors?.thumbnail && (
                <span
                  style={{
                    color: "red",
                    display: "block",
                    marginTop: 8,
                  }}
                >
                  {errors.thumbnail}
                </span>
              )}

              <p
                style={{
                  color: "#65e7c4",
                  marginTop: "10px",
                }}
              >
                Note - Thumbnail must be smaller than or equal to 512KB and must
                be exactly 490 x 320 pixels.
              </p>
            </Form.Item>
            <Form.Item label="Title">
              <Input
                value={title}
                onChange={(e) => set_title(e.target.value)}
              />
              {errors?.title && (
                <span style={{ color: "red" }}>{errors.title}</span>
              )}
            </Form.Item>

            <Form.Item label="Tag">
              <Select
                mode="tags"
                value={tag}
                onChange={set_tag}
                placeholder="Please select"
                style={{ width: "100%" }}
              />
              {errors?.tag && (
                <span style={{ color: "red" }}>{errors.tag}</span>
              )}
            </Form.Item>

            <Form.Item>
              <CustomRichTextEditor
                value={description}
                editorLabel="Description"
                onChange={(val) => set_description(val)}
                placeholder="Write something..."
              />
              {errors?.description && (
                <span style={{ color: "red" }}>{errors.description}</span>
              )}
            </Form.Item>
            <ScormUploader
              set_fileKey={set_scorm_file}
              onUploadStart={() => set_scormUploading(true)}
              onUploadComplete={() => set_scormUploading(false)}
            />

            {errors?.scorm_file && (
              <span style={{ color: "red" }}>{errors.scorm_file}</span>
            )}

            <Form.Item style={{ marginTop: 20 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading || scormUploading}
                disabled={loading || scormUploading}
                style={{ float: "right" }}
              >
                Save
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  );
}
